import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface LastLocationResult {
  saveLastLocation: (lastLocation: string | undefined) => void
  removeLastLocation: () => void
}

export const useLastLocation: () => LastLocationResult = () => {
  const { setLastLocationInStore, removeLastLocationFromStore } = useContext(AppStateContext)
  const saveLastLocation = useCallback(
    (lastLocation: string | undefined) => setLastLocationInStore(lastLocation),
    [setLastLocationInStore],
  )

  const removeLastLocation = useCallback(() => removeLastLocationFromStore(), [removeLastLocationFromStore])

  return {
    saveLastLocation,
    removeLastLocation,
  }
}
